var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[[_c('AuthWindow',{on:{"afterLogin":_vm.afterLogin}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }